import React from "react";

export default function Tag(props) {

  return (
    <div>Tag</div>
  );
}